<template>
  <BaseModal
    :name="name"
    :click-outside-to-close="clickOutsideToClose"
    :width-class="widthClass"
    @hide="emit('hide')"
    @show="emit('show')"
  >
    <div
      class="tw-flex tw-justify-between tw-space-x-8 tw-border-b tw-border-neutral-100 tw-p-6"
    >
      <div class="tw-flex tw-items-center">
        <div
          v-if="$slots.icon"
          class="tw-mr-4 tw-flex tw-h-12 tw-w-12 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full"
          :class="iconColors[iconColor]"
        >
          <div class="tw-h-6 tw-w-6">
            <slot name="icon" />
          </div>
        </div>
        <div>
          <div class="tw-text-2xl tw-font-bold">{{ header }}</div>
          <div
            v-if="description || $slots.description"
            class="tw-text-sm tw-text-neutral-400"
          >
            {{ description }}
            <slot name="description" />
          </div>
        </div>
      </div>
      <IconButton class="tw-shrink-0" @click="closeModal(name)">
        <CloseIcon />
      </IconButton>
    </div>
    <slot />
  </BaseModal>
</template>

<script setup>
import IconButton from '../../IconButton.vue'
import CloseIcon from '@/assets/images/icons/close.svg'
import { useModals } from '@/shared/composables/useModals.js'
import BaseModal from '@/shared/components/BaseModal.vue'

const emit = defineEmits(['hide', 'show'])

defineProps({
  name: {
    type: String,
    required: true,
  },
  header: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  iconColor: {
    type: String,
    default: 'DEFAULT',
  },
  widthClass: {
    type: String,
    default: 'tw-max-w-[750px]',
  },
  clickOutsideToClose: {
    type: Boolean,
    default: false,
  },
})

const iconColors = {
  DEFAULT: 'tw-bg-primary-50 tw-text-primary-500',
  red: 'tw-bg-error-50 tw-text-error-500',
  green: 'tw-bg-success-50 tw-text-success-500',
}

const { closeModal } = useModals()
</script>
